<template>
  <div class="container-fluid">
    <CRow class="pr-2">
      <CCol col="12" xl="12" class="p-0">
        <CCard>
          <CCardBody>
            <a-card class="edit-card" style="margin:0;" :body-style="{padding:0}">
              <span slot="title">
                <h6 class="w-100 mb-0 text-muted">Obchod &gt; <router-link to="/product-sets">Produktové sety</router-link></h6>
                Produktové sety
              </span>
              <span slot="extra">
                <router-link to="/product-set/new"><a-button type="primary">Nový set</a-button></router-link>
              </span>

              <div class="table-responsive">
                <a-table
                  :columns="columns"
                  :dataSource="data"
                  :rowKey="record => record.id"
                  :pagination="pagination"
                  :loading="loading"
                  size="small"
                  class="table-flush"
                >
                  <template slot="published" slot-scope="text, record">
                    <a-tag v-if="record.published == 1" color="green">Publikované</a-tag>
                    <a-tag v-else>Nepublikované</a-tag>
                  </template>
                  <template slot="items" slot-scope="text, record">
                    {{ (record.item_count != null ? record.item_count : 0) }} {{ variantWord(record.item_count) }}
                  </template>
                  <template slot="action" slot-scope="text, record">
                    <router-link :to="'/product-set/' + record.id">
                      <a-button size="small" class="mr-2">Upraviť</a-button>
                    </router-link>
                    <a-popconfirm
                      placement="topRight"
                      okText="Áno"
                      cancelText="Nie"
                      @confirm="remove(record.id)"
                    >
                      <template slot="title">
                        <h5>Naozaj zmazať set?</h5>
                        Set bude trvalo odstránený.
                      </template>
                      <a-button size="small" type="danger">Zmazať</a-button>
                    </a-popconfirm>
                  </template>
                </a-table>
              </div>
            </a-card>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { dataService } from "../_services";

export default {
  name: "product-sets",
  data() {
    return {
      data: [],
      loading: false,
      pagination: {
        hideOnSinglePage: true,
        pageSize: 50,
        showTotal: total => `Setov: ${total}`
      },
      columns: [
        { title: 'Názov', dataIndex: 'title' },
        { title: 'Slug', dataIndex: 'slug', width: '20%' },
        { title: 'Varianty', dataIndex: 'item_count', width: 120, align: 'center', scopedSlots: { customRender: 'items' } },
        { title: 'Poradie', dataIndex: 'weight', width: 90, align: 'center' },
        { title: 'Stav', dataIndex: 'published', width: 140, scopedSlots: { customRender: 'published' } },
        { align: 'right', width: 180, scopedSlots: { customRender: 'action' } }
      ]
    };
  },
  methods: {
    variantWord(n) {
      const c = Number(n) || 0;
      if (c === 1) return 'variant';
      if (c >= 2 && c <= 4) return 'varianty';
      return 'variantov';
    },
    fetch() {
      this.loading = true;
      dataService.axiosFetch('product-sets').then(data => {
        this.data = Array.isArray(data) ? data : [];
        this.loading = false;
      }).catch(() => {
        this.data = [];
        this.loading = false;
        this.$message.error('Nepodarilo sa načítať produktové sety.');
      });
    },
    remove(id) {
      dataService.axiosDelete('product-sets', id).then(res => {
        // axiosDelete vracia true pri success:true, inak message string
        if (res === true) {
          this.$message.success('Set bol zmazaný.');
          this.data = this.data.filter(s => String(s.id) !== String(id));
        } else {
          this.$message.error(typeof res === 'string' ? res : 'Zmazanie zlyhalo.');
        }
      }).catch(() => {
        this.$message.error('Chyba pri mazaní setu.');
      });
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>
